// Chip colors for transaction types, shared by every table that renders one so the pages agree.
// WTH blue, RWT orange, INQ purple (2026-09-28: inquiries used to blend in with withdrawals), anything else grey.
// INQ uses its own palette entry ("inquiry", registered in index.js) because this theme's "secondary" is pink-red.
export const inquiryPalette = { main: '#7b1fa2', light: '#ae52d4', dark: '#4a0072', contrastText: '#ffffff' };

const TRANSACTION_TYPE_COLORS = { WTH: 'primary', RWT: 'warning', INQ: 'inquiry' };

export const transactionTypeColor = (type) => TRANSACTION_TYPE_COLORS[type] || 'default';
